import { useQuery } from '@tanstack/react-query';
import { getCollectionPayments } from '@/services/credit-worker.service';

const REFETCH_INTERVAL = 60_000;

/**
 * Trae los pagos efectivamente cobrados (CollectionRecord FULL/PARTIAL) de un
 * partner en un rango de fechas. Cada pago trae timestamp real (`paid_at`),
 * desglose (capital/interes/IVA) y método de cobro.
 */
export function useCollectionPayments(partnerId: string, from: string, to: string) {
  const query = useQuery({
    queryKey: ['collection', 'payments', partnerId, from, to],
    queryFn: () => getCollectionPayments(partnerId, from, to),
    refetchInterval: REFETCH_INTERVAL,
    enabled: Boolean(partnerId && from && to),
  });

  return {
    data: query.data?.data ?? null,
    payments: query.data?.data?.payments ?? [],
    summary: query.data?.data?.summary ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => query.refetch(),
  };
}
